// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"765":"2083b61b","977":"09410de3"}[chunkId] + ".chunk.css";
};